module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUBAMAAABohZD3AAAAGFBMVEXoES3pGzbuUWX0k5/4uMD+8vT+8/T///9TdKo8AAAAN0lEQVQY02MoB4MCBnYIg6G8vKwUyg9PB/NLRKB8R3cw34jJHMwvVlDGykdXj24eqn2UggF2PwDVJ1YR95PLWwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/ge.png
// module id = 286
// module chunks = 0